const TONES = {
  rose: { bg: 'var(--rose-50)', border: 'var(--rose-300)', eyebrow: 'var(--rose-400)', label: 'var(--rose-700)' },
  lavender: {
    bg: 'var(--lavender-50)',
    border: 'var(--lavender-300)',
    eyebrow: 'var(--lavender-400)',
    label: 'var(--lavender-700)',
  },
  ink: { bg: 'var(--ink-50)', border: 'var(--ink-300)', eyebrow: 'var(--ink-400)', label: 'var(--ink-700)' },
};

// Every real photo in the design is still a placeholder (see CLAUDE.md) --
// this single component stands in everywhere a photo will eventually go, so
// swapping to real <img> tags later is a one-file change instead of an
// every-page hunt.
const PhotoPlaceholder = ({
  label,
  nota,
  ratio = '1/1',
  tone = 'rose',
  shape = 'rect',
  eyebrowText = 'Foto',
  onClick,
  style,
}) => {
  const t = TONES[tone] ?? TONES.rose;
  const isCircle = shape === 'circle';
  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : undefined,
        border: `1px dashed ${t.border}`,
        background: t.bg,
        borderRadius: isCircle ? '50%' : 'var(--radius-xl)',
        aspectRatio: isCircle ? '1/1' : ratio,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        textAlign: 'center',
        padding: 14,
        width: '100%',
        fontFamily: 'inherit',
        ...style,
      }}
    >
      <span style={{ fontSize: 10, letterSpacing: '.2em', textTransform: 'uppercase', color: t.eyebrow }}>
        {eyebrowText}
      </span>
      <span style={{ fontSize: 12.5, color: t.label, letterSpacing: '.04em' }}>{label}</span>
      {nota && <span style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>{nota}</span>}
    </Tag>
  );
};

export default PhotoPlaceholder;
